import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetCustomerNotesByCustomerInput } from './GetCustomerNotesByCustomerInput';
import { GetCustomerNotesByCustomerOutput } from './GetCustomerNotesByCustomerOutput';

export class GetCustomerNotesByCustomerService extends HttpServiceBase {

  handle = (input: GetCustomerNotesByCustomerInput): Promise<Result<GetCustomerNotesByCustomerOutput> | null> => {
    const promise = this.http.get<Result<GetCustomerNotesByCustomerOutput>>(`${this.baseUrlSislogApi}/v2/customer/customer-note/${input.customerId}`);
    return promise;
  }
}